import { FALLBACK_LANG, I18Lang, SUPPORTED_LANGS, SupportedLang } from '../constants';

export const isSupportedLang = (lang: unknown): lang is SupportedLang => {
  return typeof lang === 'string' && SUPPORTED_LANGS.includes(lang as SupportedLang);
};

export const getSupportedLang = (language?: I18Lang): SupportedLang => {
  return isSupportedLang(language) ? language : FALLBACK_LANG;
};

export const getSupportedLanguageFromConfig = (currentLang: string, configLangs?: string[]) => {
  return configLangs?.includes(currentLang) ? currentLang : FALLBACK_LANG;
};
